import React from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import CircularProgress from "@material-ui/core/CircularProgress";
import Wrapper from "../atoms/Wrapper";
import { makeStyles, withStyles } from "@material-ui/styles";
import theme from "../../theme.json";
import { change_tab } from "../../actions/tab";
import qs from "qs";
import { withRouter } from "react-router";

const StyledTabs = withStyles({
  root: {
    padding: "0.7rem 0 0.2rem",
    maxWidth: "100%",
  },
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > div": {
      maxWidth: 40,
      width: "100%",
      backgroundColor: theme.colors.primary,
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

const StyledTab = styled(Tab)``;

const StyledWrapper = styled(Wrapper)`
  flex-direction: column;
  width: 100%;
`;
const ContentWrapper = styled(Wrapper)`
  width: 100%;
`;

const useStyles = makeStyles({
  tab: {
    fontSize: "0.9rem",
    marginRight: "0.5rem",
  },
  selected_tab: {
    fontSize: "0.9rem",
    marginRight: "0.5rem",
  },
});

const CustomizedTabs = (props) => {
  const dispatch = useDispatch();
  const { isLoading, hasVerificationBeenAttempted } = useSelector(
    (state) => state.reduxTokenAuth.currentUser
  );
  const selected_index = useSelector((state) =>
    state.tab[props.type] ? state.tab[props.type].state : 0
  );

  function handleChange(e, new_idx) {
    dispatch(change_tab(props.type, new_idx));
    let query_params = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });
    query_params["tab"] = new_idx;
    props.history.push({
      pathname: window.location.pathname,
      search:
        "?" +
        Object.keys(query_params)
          .map((key) => {
            if (key === "tab" && query_params[key] === 0) {
              return "";
            }
            return `${key}=${query_params[key]}`;
          })
          .join("&"),
    });
  }

  React.useEffect(() => {
    if (props.initial_state !== undefined) {
      dispatch(change_tab(props.type, props.initial_state));
    }
  }, [dispatch, props.initial_state, props.type]);

  React.useEffect(() => {
    let query_params = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });
    if (!query_params["tab"]) {
      query_params["tab"] = 0;
    }
    dispatch(change_tab(props.type, Number(query_params["tab"])));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.search]);

  const classes = useStyles();

  return (
    <StyledWrapper>
      {isLoading || !hasVerificationBeenAttempted ? (
        <CircularProgress />
      ) : (
        <>
          <StyledTabs
            TabIndicatorProps={{ children: <div /> }}
            indicatorColor="primary"
            value={selected_index}
            onChange={handleChange}
            aria-label="tabs"
            scrollButtons="on"
            variant="scrollable"
          >
            {props.labels &&
              props.labels.map((label, idx) => (
                <StyledTab
                  disableRipple
                  label={label}
                  className={
                    idx === selected_index ? classes.selected_tab : classes.tab
                  }
                  key={`tabs${idx}`}
                />
              ))}
          </StyledTabs>
          <ContentWrapper>
            {props.contents && props.contents[selected_index]}
          </ContentWrapper>
        </>
      )}
    </StyledWrapper>
  );
};

export default withRouter(CustomizedTabs);
